import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=c54d1c06&scoped=true"
import script from "./Full.vue?vue&type=script&lang=js"
export * from "./Full.vue?vue&type=script&lang=js"
import style0 from "./Full.vue?vue&type=style&index=0&id=c54d1c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54d1c06",
  null
  
)

export default component.exports